// new HTML elements
const $wrapper = `<div class="refer">
  <div class="section-header__wrapper refer-header__wrapper">
    <div class="section-header refer-header">
      <h4 id="viewTitle" class="section-header__title">
        Get your gift
      </h4>
      <div id="viewSubtitle" class="section-header__subtitle">
        A new way to feel better.
      </div>
    </div>

    <div class="refer-container">
    </div>
  </div>
</div>`;

function appendHtml() {
  const $redemptionContent = document.getElementById("conjured_redemption");
  if ($redemptionContent) {
    const $main = document.querySelector(".main");
    $main.insertAdjacentHTML("afterbegin", $wrapper);
    const $contentContainer = document.querySelector(".refer-container");
    $contentContainer.insertAdjacentElement("afterbegin", $redemptionContent);
  }
}

function changeSectionHeader() {
  const $headerTitle = document.getElementById("viewTitle");
  const $headerSubtitle = document.getElementById("viewSubtitle");
  const $viewWrapper = document.getElementById("conjured_redemption");

  if ($viewWrapper != null) {
    $headerTitle.innerText = "Redeem your discount";
    $headerSubtitle.innerText = "Try natural remedies, back by science";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    appendHtml();
    changeSectionHeader();
  }, 1000);
});
